import '../App.css'
import { useContext, useState } from 'react'
import EmailContext from '../context/EmailContext'
import { Footer } from '../MainPage/Footer'
import { ToastEmail } from '../Toast/ToastEmail'

export const Email = ({resetValues}) => {

    const { emailValues, resetEmailValues } = useContext(EmailContext)
    const [toast, setToast] = useState({})

    const closeEmail = () => {
        resetValues(false)
        resetEmailValues()
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        let name = e.target[0].value;
        let phone = e.target[1].value;
        let mail = e.target[2].value;
        let text = e.target[3].value;

        if (phone.length !== 9) {
            setToast({
                id: 'toast-phone',
                text: 'telefono no valido',
                className: 'show'
            });
            setTimeout(() => {
                setToast({});
            }, 5000);
            return;
        }

        if (!mail.includes('@')) {
            setToast({
                id: 'toast-email',
                text: 'email no valido',
                className: 'show'
            });
            setTimeout(() => {
                setToast({});
            }, 5000);
            return;
        }

        let data = JSON.stringify({
            name: name,
            phone: phone,
            mail: mail,
            text: text,
            contact: emailValues.name,
        });
        // console.log(data)

          fetch (
            'https://server-mail.netlify.app/.netlify/functions/api/transactions',
            {
              method: 'Post',
              body: data,
            }
          );
        setTimeout(() => {
            setToast({
                id: 'toast-email-ok',
                text: 'email enviado',
                className: 'show'
            });

            e.target[0].value = '';
            e.target[1].value = '';
            e.target[2].value = '';
            e.target[3].value = '';
        }, 1);
        setTimeout(() => {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            })
            setToast({})
            resetEmailValues()
        }, 3000);
    }

    return (
        <div id='absolute' className={emailValues.statusEmail ? 'show' : 'hide'} >
            <div id='email-box' className={emailValues.statusEmail ? 'show' : 'hide'}>
                <div className='header-chat'>
                    <div className='head-home'>
                        <h3>Mandame un email</h3>
                    </div>
                </div>

                <form 
                onSubmit={(e) => handleSubmit(e)}
                 method='POST'
                  id='form'
                   className={emailValues.statusEmail ? 'showEmail' : 'hide'}>
                    <div className='input-box'>
                        <label htmlFor='name'>Nombre</label>
                        <input type='text' id='name' name='name' placeholder='Escribe tu nombre' autoComplete='on' />
                    </div>
                    <div className='input-box'>
                        <label htmlFor='phone'>Telefono</label>
                        <input type='number' id='phone' name='phone' placeholder='Escribe tu numero' autoComplete='on' />
                    </div>
                    <div className='input-box space'>
                        <label htmlFor='mail'>Correo electronico</label>
                        <input type='email' id='mail' name='email' placeholder='Escribe tu email' autoComplete='on' />
                    </div>

                    <div className='start-chat'>
                        <div className='blanter-msg'>
                            <textarea id='email_text' name='message' placeholder='Escribe un mensaje' rows='7'
                                cols='30'></textarea>
                            <div className='flex-bottom'>
                                <button type='submit' id='send_it' className='new-margin'>Enviar</button>

                            </div>
                        </div>
                    </div>
                </form>
                <button className='close-chat' onClick={() => closeEmail()} >×</button>
            </div>

            <ToastEmail id={toast.id} toastClass={toast.className} text={toast.text} />

            <Footer id={'footer-form'} />
        </div>
    )
}
